import React from "react";
import { useTranslation } from 'react-i18next';
import AnalysedDocumentsTable from "./AnalysedDocumentsTable/AnalysedDocumentsTable";

export default function AnalysedDocumentsCard(props) {
    const { t } = useTranslation()

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    {t("Documentos Analisados")}
                </div>
            </div>
            <div 
                className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
            >
                <AnalysedDocumentsTable documents={props.documents} user_data={props.user_data} />
            </div>
        </div>
    );
}
